import { render, staticRenderFns } from "./PlcFeeder_t.vue?vue&type=template&id=3b07c57f&scoped=true"
import script from "./PlcFeeder_t.vue?vue&type=script&lang=js"
export * from "./PlcFeeder_t.vue?vue&type=script&lang=js"
import style0 from "./PlcFeeder_t.vue?vue&type=style&index=0&id=3b07c57f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b07c57f",
  null
  
)

export default component.exports